module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-imperial-021-1200x2490.dfc41de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-imperial-021-1200x2490.jpg
// module id = 1107
// module chunks = 37